import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status:'',
    isLoggedin:false,
    message:'',
    user:localStorage.getItem('user'),
    business:localStorage.getItem('business'),
    remark:localStorage.getItem('remark'),
  },
  mutations: {
    auth_request(state){
      state.status='loading';
    },
    auth_success(state,user){
      state.status='success';
      state.isLoggedin=true,
      state.user=user;
    },
    auth_error(state,message=''){
      state.isLoggedin=false,
      state.message=message,
      state.status='error'
    },
    logout(state){
      state.status='';
      state.message='';
      state.isLoggedin=false;
      state.user='';
    },
    storeBussiness(state,business){
      state.business=business;
      state.status='success';
    },
    storeRemark(state,remark)
    {
      state.remark=remark;
    }

  },
  actions: {
    loginuser({commit},user){
      return new Promise((resolve,reject)=>{
        commit('auth_request');
        axios.post(
          "https://api.juzzap.com/api/loginuser",
          user,
          {
          headers:{
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin':'*',
          }
        }).then(res =>{


            if(res.data.success==1){
              localStorage.setItem('isLoggedinMsg','');
              localStorage.setItem('user',JSON.stringify(res.data.user));
              Vue.prototype.$http.defaults.headers.common['Authorization']='Bearer '+res.data.user.token;
              Vue.prototype.$user=res.data.user;
              if(res.data.user.userType=='business')
              {

                localStorage.setItem('business',JSON.stringify(res.data.user.business));
                commit('storeBussiness',JSON.stringify(res.data.user.business));
              }
              else{
                localStorage.removeItem('business');
                //Vue.prototype.$user=new Object;
              }
              localStorage.setItem('isLoggedin','true');
              commit('auth_success',JSON.stringify(res.data.user));

              resolve(res);
            }
            else if(res.data.success==3)
            {
              localStorage.setItem('isLoggedinMsg',res.data.message);
              localStorage.removeItem('user');
              commit('auth_error','Business Created But Not Active. Please Check Your Email');
              localStorage.removeItem('business');
              reject(res);
            }
            else if(res.data.success==2){
              //console.log(res.data.message);
              //commit('auth_error',res.data.message);
              localStorage.setItem('isLoggedin','false');
              localStorage.removeItem('user');
              Vue.prototype.$user=new Object;
              localStorage.removeItem('business');
              resolve(res);
            }else if(res.data.success==0){
              localStorage.setItem('isLoggedinMsg','Business Created But Not Active. Please Check Your Email');

              commit('auth_error',res.data.message);
              localStorage.setItem('isLoggedin','false');

              localStorage.removeItem('user');
              Vue.prototype.$user=new Object;
              localStorage.removeItem('business');
              reject(res);
            }
            else{
              commit('auth_error',res.data.message);
              localStorage.removeItem('user');
              Vue.prototype.$user=new Object;
              localStorage.removeItem('business');
              reject(res);
            }

        }).catch(err=>{
          commit('auth_error',err.response);
          localStorage.removeItem('user');
          Vue.prototype.$user=new Object;
          localStorage.removeItem('business');
          reject(err);
        });
      });
    },

    loginBusiness({commit},user){
      return new Promise((resolve,reject)=>{
        commit('auth_request');
        axios.post(
          "https://api.juzzap.com/api/loginbusiness",
          user,
          {
          headers:{
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin':'*',
          }
        }).then(res =>{
            if(res.data.success==1){
              localStorage.setItem('user',JSON.stringify(res.data.user));
              localStorage.setItem('business',JSON.stringify(res.data.user.business));
              localStorage.setItem('isLoggedin','true');
              commit('auth_success',JSON.stringify(res.data.user));
              commit('storeBussiness',JSON.stringify(res.data.user.business));
              resolve(res);
            }else if(res.data.success==2){
              //console.log(res.data.message);
              //commit('auth_error',res.data.message);
              localStorage.setItem('isLoggedin','false');
              localStorage.removeItem('user');
              localStorage.removeItem('business');
              resolve(res);
            }else{
              commit('auth_error',res.data.message);
              localStorage.removeItem('user');
              localStorage.removeItem('business');
              reject(res);
            }

        }).catch(err=>{
          commit('auth_error',err.response);
          localStorage.removeItem('user');
          localStorage.removeItem('business');
          reject(err);
        });
      });
    },
    login({commit},user){
      return new Promise((resolve,reject)=>{
        commit('auth_request');
        axios.post(
          "https://api.juzzap.com/api/loginagent",
          user,
          {
          headers:{
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin':'*',
          }
        }).then(res =>{
            if(res.data.success==1){
              localStorage.setItem('user',JSON.stringify(res.data.user));
              localStorage.setItem('isLoggedin','true');
              commit('auth_success',JSON.stringify(res.data.user));
              resolve(res);
            }else if(res.data.success==2){
              //console.log(res.data.message);
              //commit('auth_error',res.data.message);
              localStorage.setItem('isLoggedin','false');
              localStorage.removeItem('user');
              resolve(res);
            }else{
              commit('auth_error',res.data.message);
              localStorage.removeItem('user');
              reject(res);
            }

        }).catch(err=>{
          commit('auth_error',err.response);
          localStorage.removeItem('user');
          reject(err);
        });
      });
    },
    logout({commit}){
      return new Promise((resolve,reject)=>{
        commit('logout');
        localStorage.removeItem('user');
        Vue.prototype.$user=new Object;
        localStorage.removeItem('business');
        resolve()
      })
    },
    assignBusiness({commit},business)
    {
      localStorage.setItem('business',business);
      commit('storeBussiness');
    },

    assignRemark({commit},remark)
    {
      localStorage.setItem('remark',remark);
      commit('storeRemark');
    }
  },
  getters:{
        user: state => state.user,
        status: state =>state.status,
        message: state =>state.message,
        isLoggedin: state =>state.isLoggedin,
        business: state=>state.business,
  }
})
